import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right-white",
  "use": "icon-arrow-right-white-usage",
  "viewBox": "0 0 11 19",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 19\" id=\"icon-arrow-right-white\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m0 16.483 1.944 1.934 7.68-7.806a2 2 0 0 0 0-2.805L1.945 0 0 1.976l7.74 7.232L0 16.483Z\" fill=\"#fff\" fill-opacity=\".9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol